export default __webpack_public_path__ + "static/media/Eye_3_M_C1.c2874810.svg";